var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 49.9996C100 77.6139 77.6146 100 50.0004 100C22.3861 100 0 77.6139 0 49.9996C0 22.3854 22.3861 0 50.0004 0C77.6146 0 100 22.3854 100 49.9996Z",
    fill: "#BAE3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.676 63.5859L20.2213 70.734L19.0737 74.0734C18.6992 75.1629 19.8388 76.1835 21.0552 75.848L24.7834 74.8201L32.7643 72.6215L22.676 63.5859Z",
    fill: "#DC8744"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.782 74.8205L21.0538 75.8484C19.8374 76.1838 18.698 75.1632 19.0724 74.0737L20.2201 70.7344L24.782 74.8205Z",
    fill: "#3A556A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7201 68.1039L69.751 30.458L64.7072 25.9404L22.6763 63.5863L27.7201 68.1039Z",
    fill: "#FCD462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7624 72.6205L74.7932 34.9746L69.7494 30.457L27.7186 68.1029L32.7624 72.6205Z",
    fill: "#F6C358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7966 34.9733L64.7085 25.9377L69.7423 21.4291C70.381 20.857 71.4165 20.857 72.0551 21.4291L79.8303 28.3931C80.469 28.9652 80.469 29.8927 79.8303 30.4646L74.7966 34.9733Z",
    fill: "#E56353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5212 38.8039L72.2026 37.2979L62.1144 28.2621L60.433 29.7681L70.5212 38.8039Z",
    fill: "#EBF0F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1562 41.8136L68.8376 40.3076L58.7494 31.2719L57.068 32.7779L67.1562 41.8136Z",
    fill: "#EBF0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.3095,
    height: 54.9133,
    fill: "white",
    transform: "translate(19 21)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.53378c22dde086bc9d9d353ededd2e15.svg";
export { ForwardRef as ReactComponent };